/**
 * Returns true if the input string is a valid URL
 * @param str String
 * @returns Boolean
 */
export const isValidUrl = (str: string) => {
  let url;
  try {
    url = new URL(str);
  } catch {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export default {
  isValidUrl,
};
